module.exports = __webpack_public_path__ + "static/media/m-quegudan2.4c1bfabd.png";